/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  DeleteTournamentsIdDiscordChannelsMutationResponse,
  DeleteTournamentsIdDiscordChannelsPathParams,
} from "../types/DeleteTournamentsIdDiscordChannels.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteTournamentsIdDiscordChannelsMutationKey = () =>
  [{ url: "/tournaments/:id/discord/channels" }] as const;

export type DeleteTournamentsIdDiscordChannelsMutationKey = ReturnType<
  typeof deleteTournamentsIdDiscordChannelsMutationKey
>;

/**
 * @summary Удалить Discord каналы турнира
 * {@link /tournaments/:id/discord/channels}
 */
export async function deleteTournamentsIdDiscordChannels(
  id: DeleteTournamentsIdDiscordChannelsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteTournamentsIdDiscordChannelsMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "DELETE",
    url: `/tournaments/${id}/discord/channels`,
    ...requestConfig,
  });
  return res;
}

export function deleteTournamentsIdDiscordChannelsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteTournamentsIdDiscordChannelsMutationKey();
  return mutationOptions<
    ResponseConfig<DeleteTournamentsIdDiscordChannelsMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdDiscordChannelsPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteTournamentsIdDiscordChannels(id, config);
    },
  });
}

/**
 * @summary Удалить Discord каналы турнира
 * {@link /tournaments/:id/discord/channels}
 */
export function useDeleteTournamentsIdDiscordChannels<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteTournamentsIdDiscordChannelsMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: DeleteTournamentsIdDiscordChannelsPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteTournamentsIdDiscordChannelsMutationKey();

  const baseOptions = deleteTournamentsIdDiscordChannelsMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<DeleteTournamentsIdDiscordChannelsMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdDiscordChannelsPathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<DeleteTournamentsIdDiscordChannelsMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdDiscordChannelsPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<DeleteTournamentsIdDiscordChannelsMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdDiscordChannelsPathParams["id"] },
    TContext
  >;
}
